import React from 'react'
import Counterup from './CounterUp'

function OurClientOne() {
  return (
    <section className="counter-wraper-2 overlay-gradient-dark mt-5 mb-5">
      <div className="counter-inner content-inner-3" style={{ "backgroundImage": "url(/images/home/bg14.png)", "backgroundPosition": "center", "backgroundRepeat": "no-repeat" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-6 m-b30 mt-2">
              <div className="dlab-content-bx style-3 text-center">
                <div className="icon-content">
                  <h2 className="m-b0 text-primary"><Counterup count={2000} />+</h2>
                  <span className="title">Satisfied Clients</span>
                  <div className="icon-md text-primary">
                    <span className="icon-cell">
                      {/* <i className="flaticon-smile"></i> */}
                      <img className='client_logo' src='/images/icons/smile.png' alt='Loading..' />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 m-b30 mt-2">
              <div className="dlab-content-bx style-3 text-center">
                <div className="icon-content">
                  <h2 className="m-b0 text-primary"><Counterup count={2000} />+</h2>
                  <span className="title">Total Installations</span>
                  <div className="icon-md text-primary">
                    <span className="icon-cell">
                      {/* <i className="flaticon-line-chart"></i> */}
                      <img className='client_logo' src='/images/icons/line-chart.png' alt='Loading..' />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 m-b30 mt-2">
              <div className="dlab-content-bx style-3 text-center">
                <div className="icon-content">
                  <h2 className="m-b0 text-primary"><Counterup count={1448} />+</h2>
                  <span className="title">Providing Services</span>
                  <div className="icon-md text-primary">
                    <span className="icon-cell">
                      {/* <i className="flaticon-startup"></i> */}
                      <img className='client_logo' src='/images/icons/shuttle.png' alt='Loading..' />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 m-b30 mt-2">
              <div className="dlab-content-bx style-3 text-center">
                <div className="icon-content">
                  <h2 className="m-b0 text-primary"><Counterup count={10} />+</h2>
                  <span className="title">Years Completed</span>
                  <div className="icon-md text-primary">
                    <span className="icon-cell">
                      {/* <i className="flaticon-confetti"></i> */}
                      <img className='client_logo' src='/images/icons/confetti.png' alt='Loading..' />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default OurClientOne